import React, { useContext, useEffect } from "react";
import SideNav from "../Student/Profile/SideNav";
import User01 from "../../Svg/User01";
import GraduationHat01 from "../../Svg/GraduationHat01";
import TrendUp01 from "../../Svg/TrendUp01";
import CheckVerified01 from "../../Svg/CheckVerified01";
import PersonalInfoForm from "../Student/Profile/PersonalInfoForm";
import ParentInfo from "../Student/Profile/ParentInfo";
import EducationForm from "../Student/Profile/EducationForm";
import SocialProfiles from "../Student/Profile/SocialProfiles";
import AcademicWork from "../Student/Profile/AcademicWork";
import AlertContext from "../../context/AlertContext";
import GradiousLogoSvg from "../Student/CodeSection/CodeSection/Svg/GradiousLogo/GradiousLogoSvg";
import TestSvgIcon from "../../Svg/TestSvgIcon";
import Resume from "../Admin/Batch/Users/Resume";
import GradiousEvaluation from "./GradiousEvaluation";
import StudentsRemarks from "../Admin/Batch/Users/StudentsRemarks/StudentsRemarks";
import constants from "../../constants.js";

function ProfileUser({ learnerId }) {
  const { clcikedMenu, setClickedMenu } = useContext(AlertContext);

  useEffect(() => {
    setClickedMenu(1);
  }, [learnerId, setClickedMenu]);

  const batchType = Number(sessionStorage.getItem("batchType"));
  const isTestingBatch = batchType === constants.BATCH_TYPE.TESTING;

  const menuListItemsStudent = [
    {
      id: 1,
      icon: (
        <User01
          stroke={Number(clcikedMenu) === 1 ? "#FCFCFD" : "#667085"}
          width="20"
          height="20"
          strokeWidth="1.6"
        />
      ),
      text: "Personal Info",
      active: Number(clcikedMenu) === 1,
      path: "personalinfo",
    },
    {
      id: 2,
      icon: (
        <User01
          stroke={Number(clcikedMenu) === 2 ? "#FCFCFD" : "#667085"}
          width="20"
          height="20"
          strokeWidth="1.6"
        />
      ),
      text: "Parent Info",
      active: Number(clcikedMenu) === 2,
      path: "parentinfo",
    },
    {
      id: 3,
      icon: (
        <GraduationHat01
          stroke={Number(clcikedMenu) === 3 ? "#FCFCFD" : "#667085"}
          width="20"
          height="20"
          strokeWidth="1.6"
        />
      ),
      text: "Education",
      active: Number(clcikedMenu) === 3,
      path: "education",
    },
    {
      id: 4,
      icon: (
        <TrendUp01
          stroke={Number(clcikedMenu) === 4 ? "#FCFCFD" : "#667085"}
          width="20"
          height="20"
          strokeWidth="1.6"
        />
      ),
      text: "Academic Work",
      active: Number(clcikedMenu) === 4,
      path: "academic",
    },
    {
      id: 5,
      icon: (
        <CheckVerified01
          stroke={Number(clcikedMenu) === 5 ? "#FCFCFD" : "#667085"}
          width="20"
          height="20"
          strokeWidth="1.6"
        />
      ),
      text: "Social Profiles",
      active: Number(clcikedMenu) === 5,
      path: "socialprofile",
    },
    {
      id: 6,
      icon: (
        <GradiousLogoSvg
          fill={Number(clcikedMenu) === 6 ? "#FFFFFF" : "#F55533"}
          width="20"
          height="20"
          strokeWidth="1.6"
        />
      ),
      text: "Gradious Evaluation",
      active: Number(clcikedMenu) === 6,
      path: "Gradiousevaluation",
    },
    {
      id: 7,
      icon: (
        <TestSvgIcon
          libType={1}
          component="resume"
          stroke={Number(clcikedMenu) === 7 ? "#FFFFFF" : "#344054"}
          width="20"
          height="20"
          strokeWidth="1.6"
        />
      ),
      text: "View Resume",
      active: Number(clcikedMenu) === 7,
      path: "viewresume",
    },
    {
      id: 8,
      text: "Trainer Feedback",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.50008 12.9167H6.25009C5.08711 12.9167 4.50563 12.9167 4.03246 13.0602C2.96713 13.3834 2.13345 14.217 1.81028 15.2824C1.66675 15.7555 1.66675 16.337 1.66675 17.5M12.0834 6.25C12.0834 8.32107 10.4045 10 8.33342 10C6.26235 10 4.58341 8.32107 4.58341 6.25C4.58341 4.17893 6.26235 2.5 8.33342 2.5C10.4045 2.5 12.0834 4.17893 12.0834 6.25ZM9.16675 17.5L11.7512 16.7616C11.875 16.7262 11.9369 16.7085 11.9946 16.682C12.0458 16.6585 12.0945 16.6298 12.14 16.5965C12.1912 16.5589 12.2367 16.5134 12.3277 16.4224L17.7085 11.0417C18.2838 10.4664 18.2838 9.53362 17.7084 8.95831C17.1331 8.38302 16.2004 8.38303 15.6251 8.95833L10.2444 14.339C10.1534 14.43 10.1079 14.4756 10.0703 14.5267C10.0369 14.5722 10.0082 14.6209 9.98471 14.6722C9.95821 14.7299 9.94053 14.7918 9.90516 14.9155L9.16675 17.5Z"
            stroke={Number(clcikedMenu) === 8 ? "#FFFFFF" : "#344054"}
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      active: Number(clcikedMenu) === 8,
      path: "studentremarks",
    },
  ].filter((item) => !(isTestingBatch && [6, 7].includes(item.id)));

  return (
    <div className="profileOnPopup">
      <SideNav
        from="forpopup"
        menuListItems={menuListItemsStudent}
        title="" /* ViewResumeFunct={ViewResume} */
      />
      <div className="detailCont">
        {/* <div className="download_resume"><IconButton children={<DownloadSvgIcon />}  hierarchy={"secondary"}/></div> */}
        {Number(clcikedMenu) === 1 && (
          <PersonalInfoForm
            role="learner"
            from="onpopup"
            learnerId={learnerId}
          />
        )}
        {Number(clcikedMenu) === 2 && (
          <ParentInfo role="learner" from="onpopup" learnerId={learnerId} />
        )}
        {Number(clcikedMenu) === 3 && (
          <EducationForm role="learner" from="onpopup" learnerId={learnerId} />
        )}
        {Number(clcikedMenu) === 4 && (
          <AcademicWork role="learner" from="onpopup" learnerId={learnerId} />
        )}
        {Number(clcikedMenu) === 5 && (
          <SocialProfiles role="learner" from="onpopup" learnerId={learnerId} />
        )}
        {Number(clcikedMenu) === 6 && (
          <GradiousEvaluation learnerId={learnerId} from="onpopup" />
        )}
        {Number(clcikedMenu) === 7 && (
          <Resume learnerId={learnerId} from="onpopup" fromisLoad={true} />
        )}
        {Number(clcikedMenu) === 8 && (
          <StudentsRemarks
            from="onpopup"
            id={learnerId}
            className="studentPage"
          />
        )}
      </div>
      {/* {isLoaded && <Loading />} */}
    </div>
  );
}

export default ProfileUser;
